import * as TaskRunner from 'util/TaskRunner';

import {
  NdcColumnInferenceRequest,
  NdcColumnInferenceResponse,
  NdcColumnInferenceResult,
  NdcColumnInferenceError,
  NdcSpreadsheetImportRequest,
  NdcSpreadsheetImportResponse,
} from './constants/AntibodyNestedDataCreationSpreadsheetImportConstants';

export async function inferColumnsForNestedCreateAndRegisterSpreadsheet(
  input: NdcColumnInferenceRequest
): Promise<NdcColumnInferenceResponse> {
  const response: {
    inferredColumns: Array<NdcColumnInferenceResult | NdcColumnInferenceError>;
  } = await TaskRunner.postJSONPromise({
    url: '/1/api/antibodies:infer-columns-from-nested-create-and-register-spreadsheet',
    data: input,
  });

  // TODO(BNCH-142929): The backend is missing the rowCount, so we're returning a hardcoded value of 1 for now
  return {
    columnTypes: response.inferredColumns,
    rowCount: 1,
  };
}

export function nestedCreateAndRegisterFromSpreadsheetImport(
  input: NdcSpreadsheetImportRequest
): Promise<NdcSpreadsheetImportResponse> {
  // TODO(BNCH-142554): Update this to catch BadRequestError and return the validationErrors instead
  return TaskRunner.postJSONPromise({
    url: '/1/api/antibodies:nested-create-and-register-from-spreadsheet',
    data: input,
  });
}
